import { columnOrder, fieldMapper } from "./constants";

/**
 * @method createHeader
 * @description Used for adding header to the pdf document
 * @param pdfDocument - document created so far
 * @param header - header coming from the UI invokation of the generatePDF method
 */

export const createHeader = (pdfDocument, header) => {
  var imageData =
    "data:image/png;base64,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";
  pdfDocument.setFontSize(12);
  pdfDocument.setFontStyle("bold");
  pdfDocument.setTextColor("black");
  pdfDocument.text(header, 130, 15);
  pdfDocument.addImage(imageData, "png", 20, 10);
  return pdfDocument;
};

/**
 * @method createSubHeaders
 * @description Used for adding sub headers to the pdf document
 * @param pdfDocument - document created so far
 */
export const createSubHeaders = (
  pdfDocument,
  filteredObject,
  reportType,
  reportEntries
) => {
  pdfDocument.setTextColor("black");
  pdfDocument.setFontSize(11);
  pdfDocument.setFontStyle("bold");
  pdfDocument.text("Search Filter:", 21, 30);
  return pdfDocument;
};

/**
 * @method createTable
 * @description Used for adding the report table to the pdf document
 * @param pdfDocument - document created so far
 * @param headerRow - header data to be printed on the table's header
 * @param bodyData - body data to be printed on the table's body
 * @param totalPagesExp - Expression for total number of pages in the generated pdf
 */

export const createFilterTable = (pdfDocument, headerRow, bodyData) => {
  pdfDocument.autoTable({
    head: headerRow,
    body: bodyData,
    theme: "striped",
    tableWidth: "auto",
    margin: { top: 32, left: 20, bottom: 20 },
    styles: { lineWidth: 1 },
    headStyles: {
      fillColor: "white",
      halign: "left",
      valign: "middle",
      textColor: "black",
      overflow: "linebreak",
      fontStyle: "bold",
      fontSize: 8,
    },
    bodyStyles: {
      fillColor: "white",
      halign: "left",
      valign: "middle",
      textColor: "black",
      overflow: "linebreak",
      fontStyle: "normal",
      fontSize: 7,
    },
  });

  return pdfDocument;
};
export const createTable = (
  pdfDocument,
  headerRow,
  bodyData,
  totalPagesExp
) => {
  pdfDocument.autoTable({
    head: headerRow,
    body: bodyData,
    didDrawPage: function (pdfData) {
      // This is a hook in the process of pdf generation, it gets invoked after every page is drawn
      // Footer formatting

      var pageSize = pdfDocument.internal.pageSize;
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      const date = new Date();
      pdfDocument.text(
        `${String(date.getDate()).padStart(2, "0")}/${String(
          date.getMonth() + 1
        ).padStart(2, "0")}/${date.getFullYear()}`,
        pdfData.settings.margin.left + 5,
        pageHeight - 10
      );

      var pageString = `Page ${pdfDocument.internal.getNumberOfPages()}`;
      if (typeof pdfDocument.putTotalPages === "function") {
        pageString = `${pageString} of ${totalPagesExp}`;
      }
      pdfDocument.setFontSize(10);
      pdfDocument.text(
        pageString,
        pdfDocument.internal.pageSize.width - 40,
        pageHeight - 10
      );
    },
    theme: "grid",
    tableWidth: "auto",
    margin: { left: 20, bottom: 20 },
    columnWidth: "wrap",
    headStyles: {
      fillColor: "white",
      textColor: "black",
      // overflow: "ellipsize",
      fontStyle: "bold",
      fontSize: 8,
    },
    bodyStyles: {
      fillColor: "white",
      halign: "left",
      valign: "middle",
      textColor: "black",
      //overflow: "ellipsize",
      fontStyle: "normal",
      fontSize: 7,
    },
  });

  return pdfDocument;
};

export const processReportTableHeader = (reportEntries, reportType) => {
  let columnHeader = [];
  let headerRow = [];
  console.log("REPORTENT", reportEntries);
  Object.keys(reportEntries[0]).map((field) => {
    if (reportType && fieldMapper[reportType]) {
      fieldMapper[reportType][field] &&
        columnHeader.push(fieldMapper[reportType][field]);
    } else {
      fieldMapper[field] && columnHeader.push(fieldMapper[field]);
    }
  });
  console.log("COLHEADER", columnHeader);
  headerRow.push(columnHeader);
  return headerRow;
};

export const processReportTableFilterHeader = (filteredObject) => {
  let columnHeader = [];
  let headerRow = [];

  Object.keys(filteredObject).map((field) => {
    fieldMapper.searchFilterHeader[field] &&
      columnHeader.push(fieldMapper.searchFilterHeader[field]);
    //columnHeader.push(field.toString().replace(",", " "));
  });

  headerRow.push(columnHeader);
  return headerRow;
};

export const processReportBodyFilter = (filteredObject) => {
  let bodyRowData = [];
  let bodyData = [];
  Object.values(filteredObject).map((field) => {
    if (Array.isArray(field)) {
      field.map((f) => {
        bodyRowData.push(f.label);
      });
    } else {
      bodyRowData.push(field.toString().replace(",", " "));
    }
  });

  bodyData.push(bodyRowData);

  return bodyData;
};
export const processReportBody = (reportEntries, reportType) => {
  let bodyRowData = [];
  let bodyData = [];
  reportEntries.forEach((entry) => {
    bodyRowData = Object.keys(entry).map((field) => {
      if (reportType && fieldMapper[reportType]) {
        if (
          (reportType === "itemAudit" || reportType === "fixtureAudit") &&
          field === "delFlg"
        ) {
          return entry[field] === 1 ? "Deleted" : "Counted";
        } else {
          return fieldMapper[reportType][field] && entry[field];
        }
      } else {
        return fieldMapper[field] && entry[field];
      }
    });
    bodyData.push(bodyRowData.filter((value) => value !== undefined));
  });

  return bodyData;
};

export const reorderReportEntries = (reportEntries) => {
  let orderedReportEntries = [];

  reportEntries.forEach((entry) => {
    const entryObject = {};
    columnOrder.forEach((columnType) => {
      if (entry[columnType] !== undefined) {
        entryObject[columnType] = entry[columnType];
      }
    });
    orderedReportEntries.push(entryObject);
  });
  console.log("report",orderedReportEntries)
  return orderedReportEntries;
};
